<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

      <WiringComponent/>

    </transition>
  </div>
</template>

<script>

import WiringComponent from '@/components/wirings/WiringComponent.vue'

export default {
  name: 'Wiring',
  components: {
    WiringComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>